export default {
  isAuthenticated(state){
    console.log("The user is authenticated: " + !!state.token);
    return !!state.token;
  }
}